var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C12.0333 0 9.13319 0.879735 6.66645 2.52796C4.19971 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649925 12.0006 -0.290551 15.0166 0.288227 17.9263C0.867006 20.8361 2.29562 23.5088 4.3934 25.6066C6.49119 27.7044 9.16393 29.133 12.0736 29.7118C14.9834 30.2905 17.9994 29.9935 20.7403 28.8582C23.4811 27.7229 25.8238 25.8003 27.472 23.3335C29.1203 20.8668 30 17.9667 30 15C30 11.0217 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 19H23V8H7.00005V19ZM16.0001 21V23H20.0001V25H10.0001V23H14.0001V21H5.99205C5.86065 20.9992 5.7307 20.9725 5.60965 20.9214C5.48861 20.8702 5.37885 20.7957 5.28668 20.702C5.19452 20.6084 5.12175 20.4975 5.07256 20.3756C5.02337 20.2538 4.99873 20.1234 5.00005 19.992V7.008C5.00005 6.451 5.45505 6 5.99205 6H24.008C24.556 6 25 6.449 25 7.007V19.992C25 20.549 24.545 21 24.008 21H16.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIcon);
export default __webpack_public_path__ + "static/media/system_icon.3772e96dbecb462c7e0d942b5d0ac1d0.svg";
export { ForwardRef as ReactComponent };